/** Constant registries for texture keys, scene keys, event names, and audio keys. */

export const TEX = {
  // Player / character sprites
  PLAYER_SPRITE: "player_sprite",
  CHAR_BELLA: "char_bella",
  CHAR_KRMELO: "char_krmelo",

  // Enemies
  ENEMY_ROUTER: "enemy_router",
  ENEMY_ORB_DRONE: "enemy_orb_drone",
  ENEMY_KAMIKAZE: "enemy_kamikaze",
  ENEMY_PIRANHA: "enemy_piranha",
  ENEMY_HORNET_DRONE: "enemy_hornet_drone",
  ENEMY_MINE_DRONE: "enemy_mine_drone",
  ENEMY_MINE_DRONE_CLOSE: "enemy_mine_drone_close",
  ENEMY_MINE_DRONE_OPEN: "enemy_mine_drone_open",
  ENEMY_GUN_POD: "enemy_gun_pod",
  ENEMY_SPIKE_MINE: "enemy_spike_mine",
  ENEMY_BIO_POD: "enemy_bio_pod",
  BOSS_BRAIN: "boss_04_brain",
  BOSS_BRAIN_EXPOSED: "boss_04_brain_exposed",
  BOSS_SYNAPSE: "boss_04_synapse",
  BOSS_SNAKE: "boss_02_snake",
  BOSS_SNAKE_HEAD: "boss_02_snake_head",
  BOSS_SNAKE_BODY: "boss_02_snake_body",
  BOSS_SNAKE_TAIL: "boss_02_snake_tail",
  ENEMY_HARVESTER: "enemy_harvester",
  BOSS_HUMANOID: "boss_01_humanoid",
  BOSS_HUMANOID_JUMP: "boss_01_humanoid_jump",
  BOSS_HUMANOID_DASH: "boss_01_humanoid_dash",
  BOSS_HUMANOID_CHARGE: "boss_01_humanoid_charge",
  BOSS_HUMANOID_FIRE: "boss_01_humanoid_fire",
  ENEMY_HEALER: "enemy_healer",
  ENEMY_CHAIN_DRIFTER: "enemy_chain_drifter",
  ENEMY_NEON_MOAI: "enemy_neon_moai",
  ENEMY_DWARF: "enemy_dwarf",
  ENEMY_BOMBER: "enemy_bomber",
  ENEMY_SCOUT: "enemy_scout",

  // Coins (colored variants)
  COIN_RED: "coin_red",
  COIN_BLUE: "coin_blue",
  COIN_GREEN: "coin_green",
  COIN_YELLOW: "coin_yellow",

  // Combat ball states
  BALL_BASE: "ball_base",

  // Projectiles
  PROJ_BARK: "proj_bark",
  PROJ_LASER: "proj_laser",
  PROJ_DROOL: "proj_drool",
  PROJ_MISSILE: "proj_missile",
  PROJ_ENEMY: "proj_enemy",
  PROJ_FIREBALL: "proj_fireball",
  PROJ_SPARK: "proj_spark",
  PROJ_CHARGED: "proj_charged",
  PROJ_BOOMERANG: "proj_boomerang",
  PROJ_MINE: "proj_mine",
  PROJ_HOWL: "proj_howl",
  PROJ_ORB_NEON: "proj_orb_neon",
  PROJ_NEON_RING: "proj_neon_ring",
  PROJ_PLASMA_BOLT: "proj_plasma_bolt",

  // Bumpers
  BUMPER_COMBO: "bumper_combo",
  BUMPER_GUARD: "bumper_guard",
  BUMPER_BREAKER: "bumper_breaker",
  BUMPER_SALVAGE: "bumper_salvage",
  BUMPER_STASIS: "bumper_stasis",
  BUMPER_SLINGSHOT: "bumper_slingshot",

  // Explosions (spritesheets)
  EXPLOSION_SMALL: "explosion_small",
  EXPLOSION_MEDIUM: "explosion_medium",
  EXPLOSION_LARGE: "explosion_large",
  EXPLOSION_DEBRIS: "explosion_debris",
  EXPLOSION_MICRO: "explosion_micro",
  EXPLOSION_NEON: "explosion_neon",

  // Launcher FX (animated spritesheets)
  FX_BOLT: "fx_bolt",
  FX_CROSSED: "fx_crossed",
  FX_PULSE: "fx_pulse",
  FX_CHARGED: "fx_charged",
  FX_SPARK: "fx_spark",
  FX_WAVEFORM: "fx_waveform",

  // Hit effects (animated spritesheets)
  FX_HIT_1: "fx_hit_1",
  FX_HIT_2: "fx_hit_2",
  FX_HIT_3: "fx_hit_3",
  FX_HIT_4: "fx_hit_4",
  FX_HIT_5: "fx_hit_5",
  FX_HIT_6: "fx_hit_6",

  // Laser projectile textures
  LASER_01: "laser_01",
  LASER_02: "laser_02",
  LASER_03: "laser_03",
  LASER_04: "laser_04",
  LASER_05: "laser_05",
  LASER_06: "laser_06",

  // Launcher icons
  ICON_LAUNCHER_BARK_BLASTER: "icon_launcher_barkBlaster",
  ICON_LAUNCHER_TREAT_LAUNCHER: "icon_launcher_treatLauncher",
  ICON_LAUNCHER_LASER_POINTER: "icon_launcher_laserPointer",
  ICON_LAUNCHER_TENNIS_BARRAGE: "icon_launcher_tennisBarrage",
  ICON_LAUNCHER_DROOL_CANNON: "icon_launcher_droolCannon",
  ICON_LAUNCHER_SQUEAKY_MISSILE: "icon_launcher_squeakyMissile",
  ICON_LAUNCHER_BOUNCING_BALL: "icon_launcher_bouncingBall",
  ICON_LAUNCHER_PUPPY_PACK: "icon_launcher_puppyPack",
  ICON_LAUNCHER_BONE_BARRAGE: "icon_launcher_boneBarrage",
  ICON_LAUNCHER_HOWL: "icon_launcher_howl",
  ICON_LAUNCHER_BOOMERANG: "icon_launcher_boomerang",
  ICON_LAUNCHER_TREAT_MINE: "icon_launcher_treatMine",
  ICON_LAUNCHER_PLASMA_RAIL: "icon_launcher_plasmaRail",

  // Upgrade category icons
  ICON_UPGRADE_HP: "icon_upgrade_hp",
  ICON_UPGRADE_DAMAGE: "icon_upgrade_damage",
  ICON_UPGRADE_SPEED: "icon_upgrade_speed",
  ICON_UPGRADE_DEFENSE: "icon_upgrade_defense",
  ICON_UPGRADE_BUMPER: "icon_upgrade_bumper",
  ICON_UPGRADE_ECONOMY: "icon_upgrade_economy",
  ICON_UPGRADE_CRIT: "icon_upgrade_crit",
  ICON_UPGRADE_RANGE: "icon_upgrade_range",

  // UI / screens
  TITLE_SCREEN: "title_screen",
  TITLE_LOGO: "title_logo",
  APP_ICON: "app_icon",

  // Player equipment
  JETPACK: "jetpack",
  JETPACK_NEON: "jetpack_neon",

  // Misc
  ICON_PORTAL_EXIT: "icon_portal_exit",
  COIN_S: "coin_s",
  COIN_M: "coin_m",
  COIN_L: "coin_l",
  PARTICLE: "particle",
  SPARK: "spark",
  FIRE: "fire",
  FLASH: "flash",
  SMOKE: "smoke",
  BG_NOISE: "bg_noise",
  BG_VOID_0: "bg_void_0",
  BG_VOID_1: "bg_void_1",
  BG_VOID_2: "bg_void_2",
  PLANET_EARTH: "planet_earth",
  ASTEROID_BASE: "asteroid_base",
  ASTEROID_EXPLODE: "asteroid_explode",
} as const

export const SCENE = {
  BOOT: "Boot",
  TITLE: "Title",
  MENU: "Menu",
  STORY: "Story",
  TUTORIAL: "Tutorial",
  CHARACTER_SELECT: "CharacterSelect",
  LAUNCHER_SELECT: "LauncherSelect",
  WAVE: "Wave",
  HUD: "Hud",
  SHOP: "Shop",
  PAUSE: "Pause",
  UPGRADE_CHOICE: "UpgradeChoice",
  GAME_OVER: "GameOver",
  OPTIONS: "Options",
  DEBUG: "Debug",
  BOSS_CUTSCENE: "BossCutscene",
  SECTOR_CLEAR: "SectorClear",
} as const

export const EVENT = {
  ENEMY_DEFEATED: "enemy:defeated",
  COIN_COLLECTED: "coin:collected",
  WAVE_COMPLETED: "wave:completed",
  SHOP_OPENED: "shop:opened",

  GAME_READY: "game:ready",
  GAME_PAUSED: "game:paused",
  GAME_RESUMED: "game:resumed",
  GAME_OVER: "game:over",
  GAME_VICTORY: "game:victory",

  PLAYER_DAMAGED: "player:damaged",
  PLAYER_LEVELUP: "player:levelup",

  UPGRADE_CHOSEN: "upgrade:chosen",
  ASSET_WARNING: "asset:warning",
  BUMPER_HIT: "bumper:hit",
  BUMPER_TIP: "bumper:tip",

  COMBO_STATE_CHANGED: "combo:stateChanged",
  COMBO_TIER_REACHED: "combo:tierReached",
  COMBO_CHAIN_BONUS: "combo:chainBonus",
  BUMPER_EFFECT_APPLIED: "bumper:effectApplied",

  BALL_LAUNCHED: "ball:launched",
  BALL_STATE_CHANGED: "ball:stateChanged",
  BALL_EXPIRED: "ball:expired",
  BALL_BOUNCE: "ball:bounce",
  BALL_HIT_GAINED: "ball:hitGained",
  ENEMY_SPLIT: "enemy:split",
  GATHERER_STEAL: "gatherer:steal",
  SYNERGY_ACTIVATED: "synergy:activated",
  BOSS_SPAWNED: "boss:spawned",
  BOSS_DEFEATED: "boss:defeated",

  RUN_STATE_CHANGED: "run:stateChanged",
  HERO_STATE_CHANGED: "hero:stateChanged",
  POWER_MODE_CHANGED: "hero:powerModeChanged",
} as const

export const AUDIO = {
  BARK: "bark",
  LASER: "laser",
  BUMPER: "bumper",
  EXPLOSION: "explosion",
  PICKUP: "pickup",
  HEAL: "heal",
  DAMAGE: "damage",
  WAVE_START: "waveStart",
  PLASMA_RAIL: "plasmaRail",
  SFX_SHOTGUN: "sfx_shotgun",
  SFX_HEAVY_CANNON: "sfx_heavy_cannon",
  SFX_HADOUKEN_CHARGE: "sfx_hadouken_charge",
  SFX_HADOUKEN: "sfx_hadouken",
  SFX_FIRE_SHOT: "sfx_fire_shot",
  SFX_Goo: "sfx_goo",
  SFX_MINE: "sfx_mine",
  SFX_ROAR: "sfx_roar",
  SFX_RICOCHET: "sfx_ricochet",
  SFX_BEEP: "sfx_beep",
  SFX_BUMPER_HIT: "bumper",
  SFX_WAVE_READY: "waveStart",
  MUSIC_01: "bttf_music_01",
  MUSIC_BOSS: "bttf_music_boss",
  SFX_UI_BEEP: "sfx_ui_beep",
  SFX_UI_PRESS: "sfx_ui_press",
  SFX_UI_NAVIGATE: "sfx_ui_navigate",
  SFX_THRUSTER: "sfx_thruster",
  SFX_WARP_JUMP: "sfx_warp_jump",
  SFX_FLYBY: "sfx_flyby",
  SFX_LEVEL_UP: "sfx_level_up",
  SFX_UPGRADE_PICK: "sfx_upgrade_pick",
  SFX_SHOP_OPEN: "sfx_shop_open",
  SFX_COMBO_TIER: "sfx_combo_tier",
  SFX_VICTORY: "sfx_victory",
  SFX_GAME_OVER: "sfx_game_over",
  SFX_BALL_STATE: "sfx_ball_state",
  BALL_LAUNCH: "ball_launch",
  BALL_BOUNCE: "ball_bounce",
  BALL_EXPIRE: "ball_expire",
  BUMPER_HIT_0: "bumper_hit_0",
  BUMPER_HIT_1: "bumper_hit_1",
  BUMPER_HIT_2: "bumper_hit_2",
  BUMPER_HIT_3: "bumper_hit_3",
} as const
